import { Component, OnInit, OnDestroy } from '@angular/core';
import { ThemeService } from '../../services/theme/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-theme-modal',
  templateUrl: './custom-theme-modal.component.html',
  styleUrls: ['./custom-theme-modal.component.scss']
})
export class CustomThemeModalComponent implements OnInit, OnDestroy {
  isOpen = false;
  customColors = {
    primary: '#6366f1',
    secondary: '#8b5cf6',
    accent: '#06b6d4',
    background: '#ffffff',
    surface: '#ffffff',
    text: '#1f2937',
    textSecondary: '#6b7280',
    border: '#e5e7eb'
  };

  private themeSubscription: Subscription = new Subscription();

  // Colores predefinidos para selección rápida
  predefinedColors = [
    { name: 'Azul', value: '#3b82f6' },
    { name: 'Verde', value: '#10b981' },
    { name: 'Rojo', value: '#ef4444' },
    { name: 'Amarillo', value: '#f59e0b' },
    { name: 'Púrpura', value: '#8b5cf6' },
    { name: 'Rosa', value: '#ec4899' },
    { name: 'Cyan', value: '#06b6d4' },
    { name: 'Naranja', value: '#f97316' },
    { name: 'Índigo', value: '#6366f1' },
    { name: 'Esmeralda', value: '#059669' },
    { name: 'Granate', value: '#dc2626' },
    { name: 'Ámbar', value: '#d97706' }
  ];

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    // Cargar colores personalizados guardados
    const savedColors = localStorage.getItem('customThemeColors');
    if (savedColors) {
      this.customColors = { ...this.customColors, ...JSON.parse(savedColors) };
    }
  }

  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe();
  }

  openModal(): void {
    this.isOpen = true;
  }

  closeModal(): void {
    this.isOpen = false;
  }

  selectPredefinedColor(color: string, type: keyof typeof this.customColors): void {
    this.customColors[type] = color;
    this.previewTheme();
  }

  onColorChange(type: keyof typeof this.customColors, event: Event): void {
    const target = event.target as HTMLInputElement;
    this.customColors[type] = target.value;
    this.previewTheme();
  }

  previewTheme(): void {
    this.themeService.setCustomTheme(this.customColors);
  }

  applyCustomTheme(): void {
    this.themeService.setCustomTheme(this.customColors);
    this.closeModal();
  }

  resetToDefaults(): void {
    this.customColors = {
      primary: '#6366f1',
      secondary: '#8b5cf6',
      accent: '#06b6d4',
      background: '#ffffff',
      surface: '#ffffff',
      text: '#1f2937',
      textSecondary: '#6b7280',
      border: '#e5e7eb'
    };
    this.previewTheme();
  }

  generateFromPrimary(): void {
    // Generar colores secundarios y de acento basados en el primario
    const primary = this.customColors.primary;
    const theme = this.themeService.createCustomTheme({ primary });
    
    this.customColors.secondary = theme.colors.secondary;
    this.customColors.accent = theme.colors.accent;
    this.previewTheme();
  }

  getColorPreview(color: string): string {
    return color;
  }

  getContrastColor(backgroundColor: string): string {
    // Calcular color de contraste para el texto
    const hex = backgroundColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return brightness > 128 ? '#000000' : '#ffffff';
  }
}
